import { Link, NavLink, Outlet } from "react-router-dom";
import { ThemeToggle } from "./ThemeToggle";

const nav = [
  { to: "/pricing", label: "Pricing" },
  { to: "/products", label: "Products" },
  { to: "/shop", label: "Shop" },
  { to: "/team", label: "Team" },
  { to: "/billing", label: "Billing" },
  { to: "/blog", label: "Blog" },
];

export function Layout() {
  return (
    <div className="min-h-screen bg-bg text-copy">
      <header className="sticky top-0 z-40 border-b border-border/70 bg-bg/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6">
          <Link to="/" className="flex items-center gap-2">
            <span className="grid h-8 w-8 place-items-center rounded-xl bg-brand text-white">E</span>
            <span className="font-display text-xl tracking-tight">EdgeLaunch</span>
          </Link>
          <nav className="hidden items-center gap-5 md:flex">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `text-sm transition ${isActive ? "text-brand" : "text-copy/80 hover:text-copy"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <Link to="/login" className="rounded-full border border-border px-3 py-2 text-sm hover:bg-surface-2">
              Login
            </Link>
            <Link to="/signup" className="rounded-full bg-brand px-4 py-2 text-sm font-medium text-white hover:bg-brand-2">
              Start Free
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <Outlet />
      </main>

      <footer className="border-t border-border/60 py-8">
        <div className="mx-auto flex max-w-6xl flex-col justify-between gap-3 px-4 text-sm text-copy/70 md:flex-row md:px-6">
          <p>Built for Cloudflare Pages, Workers, and Functions.</p>
          <p>EdgeLaunch © 2026</p>
        </div>
      </footer>
    </div>
  );
}
